/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from "react";

export default function MarketWidgetNav({
items = [],
activeItem,
onSelect
}) {

return (

    <div
        className="
            w-64
            shrink-0
        "
    >

        <div
            className="
                bg-white
                rounded-2xl
                border
                border-slate-200
                shadow-sm
                overflow-hidden
                sticky
                top-6
            "
        >

            {/* HEADER */}

            {/*<div*/}
            {/*    className="*/}
            {/*        px-5*/}
            {/*        py-4*/}
            {/*        border-b*/}
            {/*        bg-slate-50*/}
            {/*    "*/}
            {/*>*/}
            {/*    <h3*/}
            {/*        className="*/}

            {/*            text-sm*/}
            {/*            font-semibold*/}
            {/*            text-slate-700*/}
            {/*            uppercase*/}
            {/*            tracking-wide*/}
            {/*        "*/}
            {/*    >*/}
            {/*        Analytics*/}
            {/*    </h3>*/}
            {/*</div>*/}

                <button
                    className={`
                        w-full
                        text-center
                        px-8
                        py-4
                        transition-all
                        duration-200
                        border-b border-slate-100
                        bg-slate-600
                        text-white
                        font-bold
                    `}
                >

                  Analytics

                </button>



            {/* MENU ITEMS */}

            <div>

                {items.map((item, index) => (

                    <button
                        key={item}
                        onClick={() => onSelect(item)}
                        className={`
                            w-full
                            text-left
                            px-5
                            py-4
                            transition-all
                            duration-200

                            ${
                                index !== items.length - 1
                                    ? "border-b border-slate-100"
                                    : ""
                            }

                            ${
                                activeItem === item
                                    ? `
                                        bg-blue-400
                                        text-white
                                        font-medium
                                    `
                                    : `
                                        bg-white
                                        text-slate-700
                                        hover:bg-slate-50
                                    `
                            }
                        `}
                    >

                        {item}

                    </button>

                ))}

            </div>

        </div>

    </div>

);

}
